<template>
  <div class="card">
    <div class="card__transferred-icon" v-if="user.profile.is_transferred" title="Перевелся">
      <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="7.5" cy="7.5" r="7" fill="currentColor" stroke="currentColor"/>
        <path d="M4.1665 5.41732H10.8332M10.8332 5.41732L8.78054 3.33398M10.8332 5.41732L8.78054 7.50065" stroke="#ffffff"/>
        <path d="M11.25 9.58268L4.16667 9.58268M4.16667 9.58268L6.2193 11.666M4.16667 9.58268L6.2193 7.49935" stroke="#ffffff"/>
      </svg>
    </div>
    <router-link :to="`/user/info/${user.id}/personal`" class="card__head">
      <AppAvatarPreview size="42px" :avatar="user.profile.avatar" />
      <div class="card__title">
        {{ user.profile.surname }} {{ user.profile.name }}<br>
        {{ user.profile.patronymic }}
      </div>
    </router-link>
    <div class="card__body">
      <div class="card__row">
        <AppSelect title="Статус"
                   placeholder="Укажите статус"
                   width="245px"
                   :value="currentStatus"
                   :options="statusList"
                   @value-changed="updateStatus"
        />
      </div>
      <div class="card__row">
        <AppButton type="main"
                   title="Перевод"
                   width="100%"
                   @click.native="showTransferModal(user.id)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AppAvatarPreview from '@/components/page/files/AppAvatarPreview'
import AppSelect from '@/components/page/input/AppSelect'
import AppButton from '@/components/page/button/AppButton'

export default {
  name: 'subordinate-user-card',
  components: {
    AppButton,
    AppSelect,
    AppAvatarPreview
  },
  props: {
    user: Object
  },
  computed: {
    currentStatus () {
      return { id: this.user.status_id, name: `${this.getStatusName(this.user.status_id)}` }
    },
    statusList () {
      return this.$store.getters.usersStatusList
    }
  },
  methods: {
    getStatusName (statusId) {
      return this.$store.getters.getStatusById(statusId)
    },
    updateStatus (status) {
      const data = {
        userId: this.user.id,
        roles: this.user.roles,
        statusId: status.id
      }
      this.$emit('update-status', data)
    },
    showTransferModal (userId) {
      this.$emit('show-transfer-modal', userId)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.card {
  position: relative;
  display: block;
  width: auto;
  border: 1px solid $color__forest-wolf;
  border-radius: 3px;
  box-shadow: 0 4px 4px rgba(23, 63, 125, 0.22);
  transition: .3s;

  &__transferred-icon {
    position: absolute;
    top: 10px;
    right: 10px;
    left: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    @include size(14px);
    color: $color_seventh;
  }

  &__head {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    padding:  20px;
    background: $color__forest-wolf;
    transition: .3s;

    &:hover {
      background: $color__orange;

      .card__title {
        color: $color__white;
      }
    }
  }

  &__body {
    padding:  10px 20px 25px;
  }

  &__title {
    color: $color__brown;
    margin-left: 20px;
    transition: .3s;
    line-height: 1.20;
  }

  &__row {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
